// Used for denoting which requests are for which workload when sent to OfficeHome API
// Keep in sync with files from OfficeHome repo:
// - 'OfficeHome.Shared.Constants.Workload.cs'
// - 'bundle.sw.js' (for 'workloadQueryParameterValue')
// - 'workload-enum.ts'
// - 'workload-query-parameter.enum.ts'
export var OfficeWorkload;
(function (OfficeWorkload) {
    OfficeWorkload["Antp"] = "antp";
    OfficeWorkload["Embed"] = "embed";
    OfficeWorkload["Hwa"] = "pwa";
    OfficeWorkload["OfficeHome"] = "officehome";
    OfficeWorkload["OfficeHomeReact"] = "officehomereact";
})(OfficeWorkload || (OfficeWorkload = {}));
//# sourceMappingURL=OfficeWorkload.js.map